module.exports = __webpack_public_path__ + "static/media/transaction_icon.fde36f19.svg";